'use strict';
var React = require('react');
var _ = require('underscore');
var styleHelper = require('../../helper/styleHelper');
var textHelper = require('../../helper/util').Text;


var Tabs = React.createClass({

  getInitialState: function () {
    return {
      selectedIndex: parseInt(this.props.selectedIndex, 10)
    };
  },


  render: function () {
    var w = styleHelper.getWidth(this.props);
    var h = styleHelper.getHeight(this.props);
    var items = textHelper.delimitToWords(styleHelper.getText(this.props));
    var itemW = w / items.length;
    var indicatorHeight;
    var indicatorWidth;
    var dividerPercentHeight;
    var dividerColor;
    var dividerTop;
    var indicatorTop;
    var indicatorLeft;

    var style = {
      borderColor: this.props.borderColor,
      borderWidth: styleHelper.getBorderWidth(this.props) || 1,
      borderStyle: 'none',
      borderBottomStyle: styleHelper.getBorderVisible(this.props) ? 'solid' : 'none',
      textAlign: 'center',
      boxSizing: 'border-box',
      overflow: 'hidden',
      position: 'relative'
    };
    var dividerStyle;
    var indicatorStyle;
    var textStyle;
    var margin = 0;
    var left;
    var tempStyle;

    style = styleHelper.StyleUtil(this.props).size().background().text().default(style).style;
    style.borderColor = _.isUndefined(this.props.indicatorHeight) ? '#000' : style.borderColor;
    indicatorHeight = this.props.indicatorHeight || 6;
    indicatorWidth = _.isUndefined(this.props.indicatorPercentWidth) ? itemW : (itemW * this.props.indicatorPercentWidth * 0.01);
    dividerPercentHeight = _.isUndefined(this.props.dividerPercentHeight) ? (h * 0.6) : (h * this.props.dividerPercentHeight * 0.01);
    dividerColor = _.isUndefined(this.props.dividerColor) ? '#000' : this.props.dividerColor;
    dividerTop = (h - dividerPercentHeight) / 2;
    indicatorTop = h - indicatorHeight;
    dividerStyle = {
      width: itemW,
      height: dividerPercentHeight,
      top: dividerTop,
      borderStyle: 'none',
      boxSizing: 'border-box',
      borderLeftStyle: 'solid',
      borderWidth: 1,
      borderColor: dividerColor,
      position: 'absolute',
      pointerEvents: 'none'
    };
    indicatorStyle = {
      position: 'absolute',
      left: "50%",
      top: indicatorTop,
      transform: 'translateX(-50%)',
      width: indicatorWidth,
      height: indicatorHeight,
      border: 'none',
      backgroundColor: this.props.selectedColor,
      pointerEvents: 'none',
      zIndex: -1
    };
    textStyle = {
      width: itemW - margin * 2,
      height: '100%',
      position: 'absolute',
      top: 0,
      lineHeight: h + 'px',
      overflow: 'hidden'
    };

    return (
      <div className="component contents-layout content" style={style}>
        {
          items.map(function (tx, index) {
            var isSelected = index === this.state.selectedIndex;
            left = itemW * index;
            tempStyle = _.extend({}, textStyle);
            tempStyle.left = left + margin;
            tempStyle.zIndex = index + 1;
            if (isSelected) {
              tempStyle.color = styleHelper.getSelectedTextColor(this.props)
            }
            return (
              <div key={index} style={tempStyle} onClick={this.onItemClick.bind(this, null, index)}>
                <label>{tx}</label>
                {isSelected && <div style={indicatorStyle}></div>}
              </div>
            )
          }, this)
        }
        {
          items.map(function (tx, index) {
            left = itemW * index;
            tempStyle = _.extend({}, dividerStyle);
            tempStyle.left = left;
            if (index === 0) {
              tempStyle.borderLeftStyle = 'none';
            } else {
              tempStyle.borderLeftStyle = 'solid';
            }
            return (
              <div key={index} style={tempStyle}></div>
            )
          }, this)
        }
      </div>
    );
  },

  componentDidMount: function () {
    $(ReactDOM.findDOMNode(this)).bind('itemClick', this.onItemClick);
  },

  onItemClick: function (e, index) {
    this.setState({selectedIndex: index});
  }

});

module.exports = Tabs;



// WEBPACK FOOTER //
// ./src/views/Components/Tabs.jsx